import { yupResolver } from "@hookform/resolvers/yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { createBusinessUnit, resetListBusinessUnit } from "store/actions";
import * as yup from "yup";
import { emailPrefix, userRecordStatus, userRecordStatusMode } from "./utils";

const CreateUser = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["businessUnit"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.BusinessUnit);
  const {
    loadingCreate,
    errorCreate,
    create: userCreate,
    loadingListRole,
    errorListRole,
    listRole: userRoleList,
  } = userManagement;
  const schema = yup.object().shape({
    ten: yup.string(),
    mst: yup.string(),
    dchi: yup.string(),
    // record_status: yup.string().required(
    //   t("form.validate.select", {
    //     title: t("form.record_status.name"),
    //   })
    // ),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ten: "",
      mst: "",
      dchi : ""
      // record_status: userRecordStatusMode.ACTIVE,
    },
  });

  // Get List Data For Select
  useEffect(() => {
    // dispatch(listEmployee({ page: -1 }));
    // dispatch(listUserRole());
    // return () => {
    //   dispatch(resetListEmployee());
    //   dispatch(resetListUserRole());
    // };
  }, [dispatch]);

  // Action Dispatch
  useEffect(() => {
    if (userCreate && userCreate.success) {
      addToast(t("form.submit.create.user.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetListBusinessUnit());
      setTimeout(() => {
        history.push("/business-unit-manager/list");
      }, 1000);
    }
  }, [addToast, dispatch, history, t, userCreate]);

  const setDataUserProfile = data => {
   
    setValue("mst", userProfile.mst ? userProfile.mst : "");
    setValue("dchi", userProfile.dchi ? userProfile.dchi : "");
    setValue("ten", userProfile.ten ? userProfile.ten : "");

  };

  const onSubmit = values => {
    dispatch(
      createBusinessUnit({
        ten: values.ten,
        mst: values.mst,
        dchi : values.dchi
      })
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.create")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title={t("title.manager")}
            breadcrumbItem={t("title.create")}
          />
          <Row className="row-cols-1 EmployeeCreate">
            <Col>
              <Card className="EmployeeCreate__Card">
                <CardBody>
                  <Form>
                    <Row className="row-cols-1 row-cols-md-2">
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="ten">
                            {t("table.ten")}
                          </Label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("ten")}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="mst">{t("table.mst")}</Label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("mst")}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="dchi">{t("table.dchi")}</Label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("dchi")}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="justify-content-end">
                      <Col className="col-auto">
                        <Button
                          color="primary"
                          className="btn-label"
                          type="button"
                          onClick={() => {
                            handleSubmit(onSubmit)();
                          }}
                          disabled={loadingListRole || loadingCreate}
                        >
                          <i className="bx bx-save label-icon"></i>
                          {t("form.save")}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateUser;
